<template>
    <div class="container">
      <div class="breadCrumpWrap"  v-if="searchUserName">
          <span class="backBtn" @click="back"> <i class="el-icon-arrow-left"></i> 返回</span>
          <div class="itemBox">
              <span>
                  <span class="name">{{searchUserName}}</span>
                  <span class="lineIcon">&gt;</span>
                  <span class="name">商品列表</span>
              </span>
          </div>
      </div>
      <div class="breadCrumpWrap"  v-if="!searchUserName">
          <div class="itemBox">
              <span>
                  <span class="name">商品列表</span>
              </span>
          </div>
      </div>
        <div class="pageTitleBox" v-if="searchUserName">
          <div class="pageTitleName">{{searchUserName}}</div>
          <div class="rightBtnBox">
            <el-button type="primary" size="mini" @click="toAddGoodsPage" v-show="function_editGoods">添加商品</el-button>
            <el-button type="primary" size="mini" @click="openAddGoods" v-show="function_editGoods">批量上传商品</el-button>
            <downloadbtn :name="searchUserName" :id="searchUser"></downloadbtn>
          </div>
        </div>
        <div class="searchBox">
           <div class="left">
                <el-form :inline="true">
                    <el-form-item>
                        <el-input placeholder="ID/商品名称/款号" v-model="formObj.fuzzyQuery" clearable></el-input>
                    </el-form-item>
                   <!-- <el-form-item>
                      <el-select v-model="searchUser" filterable placeholder="请选择用户">
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                          </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item v-if="!searchUserName">
                      <el-select  @change="changeUserOption" v-model="searchUser"  filterable  placeholder="请选择供应商"
                          >
                          <el-option
                            v-for="item in options_user"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                          </el-option>
                        </el-select>

                    </el-form-item>


                    <el-form-item>
                      <el-select v-model="searchBrand" filterable placeholder="请选择品牌">
                          <el-option
                            v-for="item in options_brand"
                            :label="item.text"
                            :value="item.value">
                          </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item >
                        <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="right" v-if="!searchUserName" >
                <el-button type="primary" @click="download" :loading="importLoading"  >导出全部商品</el-button>
            </div>
        </div>
        <div class="tableBox" >
            <el-table v-loading="isLoading" :data="tableData" size="small">
                <el-table-column label="序号" width="70">
                    <template slot-scope="scope">{{ total-((searchObj.page-1)*searchObj.num+ scope.$index) }}</template>
                </el-table-column>
                <el-table-column label="商品ID">
                    <template slot-scope="scope">{{ scope.row.item_id }}</template>
                </el-table-column>
                <el-table-column label="图片">
                    <template slot-scope="scope">
                        <el-image
                            style="width: 64px; height: 64px"
                            :src="scope.row.mallItemFileUrl"
                            fit="cover"
                        >
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label="商品名称">
                    <template slot-scope="scope">
                        {{scope.row.itemName}}
                    </template>
                </el-table-column>
                <el-table-column label="款号">
                    <template slot-scope="scope">{{ scope.row.styleNumber }}</template>
                </el-table-column>
                <el-table-column label="当前定价">
                    <template slot-scope="scope">¥ {{ scope.row.price }} 元</template>
                </el-table-column>
                <el-table-column label="可销售库存">
                    <template slot-scope="scope">{{ scope.row.stock }} 件</template>
                </el-table-column>
                <el-table-column label="所属供应商">
                    <template slot-scope="scope">{{ scope.row.supplierName }}</template>
                </el-table-column>
                <el-table-column label="品牌">
                    <template slot-scope="scope">{{ scope.row.brand }}</template>
                </el-table-column>


                <el-table-column label="上架状态">
                     <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.itemState == '1'">在售</el-tag>
                        <el-tag type="info" v-else>已下架</el-tag>
                    </template>
                </el-table-column>


                <el-table-column label="操作" width="240">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" v-if="scope.row.itemState == 1" @click="changeState(scope.row, scope.$index)"  v-show="function_editGoods" >下架</el-button>
                        <el-button type="success" size="mini" v-else @click="changeState(scope.row, scope.$index)"  v-show="function_editGoods">上架</el-button>
                        <el-button type="primary" size="mini" @click="toDetail(scope.row)" v-show="function_viewGoodsDetail">查看</el-button>
                        <el-button type="primary" size="mini" @click="toEdit(scope.row)" v-show="function_editGoods">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
                :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>

        <uploadgroup v-show="isShowUploadGroupModal" :info="currentUploadModal" @close="closeUploadModal" @success="closeUploadModalAndSucess"></uploadgroup>
    </div>
</template>

<script>
    import {
        json,
        wordData
    } from '@/common/common.js'
    import {
        ajaxPost, api
    } from '@/common/request.js'
    import {
        utils
    } from '@/common/common.js'
    import {
      getSignStr
    } from '@/common/tool.js'
    import {
      ajaxImport
    } from '@/common/request_import.js'
    import { saveAs } from 'file-saver'
    import moment from 'moment'
    import uploadgroup from '@/components/uploadgroup.vue'
    import downloadbtn from '@/components/downloadGoodsBtn.vue'
    export default {
        name: 'adminIndex',
        data() {
            return {
              importLoading:false,
              loadingOptionUser:'',
                lastPage:'',
                newLinkParamObj:{},
                isShowAddOrderModal:false,
                isLoading: false,
                msg: 'Welcome to Your Vue.js App',
                formObj: {
                    fuzzyQuery: '',
                },
                searchUserName:'',
                searchBrand:'',
                searchUser:'',
                searchObj: {
                    page: 1,
                    num: 10,
                },
                options_user:[],
                options_brand:[],
                //表格
                tableData: [],
                multipleSelection: [],
                //分页
                total: 0,
                currentAuthList: "12312312312312",
                isShowModal: false,
                downloadUrl:'',

                 isShowUploadGroupModal:false,
                 currentUploadModal:{},

            }
        },

        computed: {

            function_viewGoodsDetail() {
              return utils.getCurrentFunction().indexOf("viewGoodsDetail")>-1
            },
            function_editGoods() {
              return utils.getCurrentFunction().indexOf("editGoods")>-1
            },

            IMG_PREV() {
                return api.imgPrev
            },
            adminId() {
                return utils.getAdminId()
            },
            token(){
              return utils.getToken()
            },

        },
        watch: {
            $route: {
                handler: function(route) {
                    this.searchObj.num = Number(this.$route.query.size)
                    ? Number(this.$route.query.size)
                    : 10;
                    this.searchObj.page = Number(this.$route.query.page)
                    ? Number(this.$route.query.page)
                    : 1;
                    this.formObj.fuzzyQuery = this.$route.query.search || "";
                    this.searchBrand=this.$route.query.searchBrand || "";
                    this.searchUser=this.$route.query.searchUser || "";
                    this.searchUserName=this.$route.query.searchUserName || "";
                    // this.getCurrentOptionByOneUserId(this.searchUser)
                    this.getTableLists();
                },
                immediate: true
            }
        },
        components: {
          uploadgroup,downloadbtn
        },
        methods: {
          // 跳转“添加商品”页面
          toAddGoodsPage () {
            this.$router.push('/goods/add?userId=' + this.$route.query.searchUser)
          },
          openAddGoods() {
            this.isShowUploadGroupModal=true
            this.currentUploadModal={
              user_organization_name:this.searchUserName,
              user_id:this.searchUser
            }

          },
          closeUploadModal(){
            console.log("批量上传关闭方法被触发")
            this.isShowUploadGroupModal = false
          },
          closeUploadModalAndSucess(){
            console.log("批量上传关闭并且成功方法被触发")
            this.isShowUploadGroupModal = false
            this.currentUploadModal = {}
            this.getTableLists();
          },
          getBrandOption(){
            let _this=this
            let arg={
              userId:this.searchUser
            }
            _this.options_brand =[{text:"所有品牌",value:""}]
            ajaxPost('/commodity/brandListByUser', arg).then(function(res){
              console.log(res)
              if(res.errorCode==200){
                res.data.map(function(item,index){
                  let buffer={
                    text:item.item_display_name,
                    value:item.item_display_name
                  }
                  _this.options_brand.push(buffer)
                })

              }
            })
          },
          changeUserOption(){//获取品牌-选项
            let _this=this
            this.searchBrand=''
            this.getBrandOption()
          },
          getCurrentOptionByOneUserId(param){
            let _this=this
            if(!param){
              return false
            }
            let userId=param
            let arg={
              userId:userId
            }
            // _this.options_user=[]
            // // 查询基本信息
            // ajaxPost('/admin/getDwUserInfo', arg).then(function(res) {
            //   if(res.errorCode==200){
            //     let resObj=res.data[0]||{}
            //     let name=resObj.user_organization_name||resObj.user_individual_name
            //     let buffer={text:name,value:userId}
            //     _this.options_user.push(buffer)
            //   }
            // }, function(res) {})
            // 查询品牌
            let brandArr=[{text:"所有品牌",value:""}]
            ajaxPost('/commodity/brandListByUser', arg).then(function(res){
              if(res.errorCode==200){
                res.data.map(function(item,index){
                  let buffer={
                    text:item.item_display_name,
                    value:item.item_display_name
                  }
                  brandArr.push(buffer)
                })
              }else{
                brandArr=[{text:"所有品牌",value:""}]
              }
              _this.options_brand=brandArr
            })

          },
          getOptionUser(query) {//获取选项-用户
            let _this = this
            let newQuery=this.trimAll(query)
            console.log(query,newQuery)
            let arg={
              num: 10000,
              page: 1,
              fuzzyQuery:newQuery
            }
            this.loadingOptionUser = true
            _this.options_user =[]
            ajaxPost('/admin/userList', arg).then(function(res) {
              console.log(res)
              _this.loadingOptionUser = false
              let initOption={text:"全部用户",value:""}
              _this.options_user.push(initOption)
              if (res.data && res.data.userList) {

                res.data.userList.forEach(function(item, index) {
                  let buffer={
                    // text:( item.user_organization_name||item.user_individual_name)+'-'+item.user_id,
                    text:item.user_organization_name||item.user_individual_name,
                    value:item.user_id,
                  }
                  _this.options_user.push(buffer)

                })

              }
              console.log(1111111111)
            }, function(res) {

              _this.options_user =[{text:"全部用户",value:""}]
              _this.loadingOptionUser = false
            })
          },
          download() {
            let _this = this
            if(_this.importLoading){
              _this.$message({
                message: "正在下载中，请耐心等待", //接口返回一个页面
                type: 'warning',
                duration: 1500
              });
              return false
            }
            let userId=''
            let token=''
            let image_type="12104"//12101为原图，12102为大图，12104为缩略图
            let item_state=""   //商品状态，0为无效（删除），1为有效（上架），2为有效但不展示（下架），留空为全量导出

            var signArg={
              user_id: userId,
              user_token: token,
              image_type:image_type,
              item_state:item_state,
            }
            var signStr=getSignStr(signArg)
            var arg = {
              user_id: userId,
              user_token: token,
              image_type:image_type,
              item_state:item_state,
              sign:signStr
            };
            var url = '/digital_warehouse_php/?s=item&op=export'
            _this.importLoading=true
            ajaxImport(url, arg).then(function(res) {
              console.log(res)
              _this.importLoading=false
              if(res.error_code=='0'){
                _this.$message({
                  message: "下载商品成功", //接口返回一个页面
                  type: 'success',
                  duration: 2000
                });
                saveAs(res.data.file, `zciiss数字云仓_所有商品_${moment().format("YYYY年MM月DD日HH时mm分")}`);
                // window.location.href=res.data.file
                // let url=res.data.file
                // _this.$alert('下载地址：'+url, '下载成功', {
                //   confirmButtonText: '确定',
                //   callback: action => {
                //     window.location.href=url
                //   }
                // });

              }else{
                _this.$message({
                  message: res.error_msg||"请求报错", //接口返回一个页面
                  type: 'error',
                  duration: 1500
                });
              }
            }).catch(function(res){
              _this.importLoading=false
            })


          },
            getParams(){
              this.lastPage=this.$route.query.from
            },
            back() {
                this.$router.back()
            },
            closeModal() {
                console.log('list.vue 的关闭事件')
                this.isShowModal = false
            },
            openAuth(list) {
                this.currentAuthList = list
                this.isShowModal = true
            },

            openNewLinkModal(list){
                console.log(list)
                this.isShowAddOrderModal=true
                this.newLinkParamObj=list
            },
            toAdd(){
              this.$router.push({
                  name: 'userAdd',
              })
            },
            toDetail(list) {
                this.$router.push('/goods/detail?id=' + list.item_id + '&userId=' + list.user_id)
            },
            toEdit(item) {
              this.$router.push('/goods/edit?id=' + item.item_id + '&userId=' + item.user_id)
            },
            fuzzySearchClick() {
                this.searchObj.page = 1;
                this.updateRouter();
            },
            updateRouter() {
                this.$router
                    .push(
                    "/goods/list?search=" +
                        this.formObj.fuzzyQuery +
                        "&page=" +
                        this.searchObj.page +
                        "&size=" +
                        this.searchObj.num+
                        "&searchBrand=" +
                        this.searchBrand+
                        "&searchUser=" +
                        this.searchUser+
                        "&searchUserName="+
                        this.searchUserName
                    )
            },
            getTableLists() {
                let _this = this
                this.isLoading = true
                ajaxPost('/commodity/mallItemListByht', {
                    fuzzyQuery: this.formObj.fuzzyQuery,
                    page: this.searchObj.page,
                    num: this.searchObj.num,
                    brand:this.searchBrand,
                    queryString:this.searchUser
                }).then(function(res) {
                    console.log('/commodity/mallItemListByht', res)
                    _this.tableData = []
                    _this.isLoading = false
                    if (res.data && res.data.mallItemList) {
                        _this.total = parseInt(res.data.totalCount)
                        res.data.mallItemList.forEach(function(item, index) {
                            item.mallItemFileUrl = item.mallItemFileUrl ? _this.IMG_PREV + item.mallItemFileUrl: ''
                            let buffer = item
                            _this.tableData.push(buffer)

                        })

                    }
                }, function(res) {
                    _this.isLoading = false
                })
            },
            handleSizeChange(size) { //分页：每页n条
                this.searchObj.num = size
                this.searchObj.page = 1
                this.updateRouter()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.searchObj.page = page
                this.updateRouter()
            },

            // 商品上下架
            changeState(row, index) {
                console.log(row, index)
                let confirmTip = row.itemState == 1 ? '下架' : '上架'
                this.$confirm(confirmTip + '该商品吗？ （名称：' + row.itemName + '）（款号：' + row.styleNumber + '）', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.updateItemState(row, index)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    })
                })
            },
            updateItemState(row, index) {
                let status = row.itemState == 1 ? 2 : 1   // 1 - 上架  2 - 下架
                ajaxPost('/commodity/updateItemState', {
                    itemId: row.item_id,
                    itemState: status
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        this.tableData[index].itemState = status
                        let tip = status == 1 ? '上架成功' : '下架成功'
                        this.$message.success(tip)
                    } else {
                        let errTip = status == 1 ? '上架失败' : '下架失败'
                        this.$message.error(errTip)
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
        },
        created() {

        },

        mounted() {
          this.getOptionUser()
          this.getBrandOption()
        }
    }
</script>

<style scoped lang="scss">
    .avatarImg{width: 60px;height:60px;}
    .searchBox {
        padding: 0.25rem 0.25rem 0;

        .left {
            float: left;
        }

        .right {
            float: right;
        }
    }

    .searchBox:after {
        content: "";
        display: block;
        clear: both;
    }

    .tableBox {
        padding: 0.25rem;
    }

</style>



// WEBPACK FOOTER //
// src/pages/goods/list.vue